export default {
  approvedHolidays: [],
  unapprovedHolidays: [],
  confirmedHolidays: [],
  userHolidays: [],
};
